import { ICta } from "@/utils/types";
import { Button } from "./button";

export function Cta(props: ICta) {
  return (
    <div className="relative px-4">
      <div className="relative z-10 bg-white component-padding component-gap flex justify-center items-center p-8 md:p-16 text-darkGrey">
        <div className="flex flex-col items-center justify-center component-gap max-w-5xl text-center">
          <p className="heading">{props.title}</p>
          <p className="opacity-80">{props.description}</p>
          {props.buttons && (
            <div className="flex justify-center gap-4">
              {props.buttons.map((button, i) => {
                return (
                  <Button key={i} link={button.link} label={button.label} />
                );
              })}
            </div>
          )}
        </div>
      </div>
      <div className="bg-darkGrey w-full h-1/2 absolute bottom-0 right-0 left-0 z-0"></div>
    </div>
  );
}
